define('presentation/shell/viewModels/dashboardViewModel',[], function() {

    return function() {

    };
});
